import moment from 'moment-timezone';
import { displayDateTime } from '../common/datePresentation';

export function displaySchoolTimestamp(value, language = 'pl') {
  if (!value) return '';
  const instant = moment.parseZone(value, moment.ISO_8601, true);
  return instant.isValid() ? displayDateTime(instant.tz('Europe/Warsaw').format(), language) : '';
}

export function cancellationKind(lesson) {
  if (Object.prototype.hasOwnProperty.call(lesson, 'cancellationInfo')) return lesson.cancellationInfo ? lesson.cancellationInfo.kind : null;
  // Compatibility while the additive API projection rolls out.
  if (String(lesson.participationStatus).startsWith('cancelled')) return 'participant';
  return lesson.lessonStatus === 'cancelled' ? 'school' : null;
}
